<div class="modal" tabindex="-1">
  <div
    class="modal-dialog modal-dialog-centered  {{ size }}"
    [ngClass]="{ 'text-center': alignCenter }">
    <div class="modal-content">
      <div class="modal-header" *ngIf="showHeader">
        <h5 class="modal-title">{{ title }}</h5>
        <button
          *ngIf="showCloseBtn"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="close()"></button>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
        <p class="fs-6 mt-4" *ngIf="message">{{ message }}</p>
      </div>
      <div
        class="modal-footer"
        [ngClass]="{ 'justify-content-center': alignCenter }"
        *ngIf="showSubmitBtn || showCancelBtn">
        <button
          type="button"
          class="btn btn-primary"
          (click)="submit()"
          *ngIf="showSubmitBtn">
          {{ submitLabel }}
        </button>
        <button
          type="button"
          class="btn btn-dark"
          data-bs-dismiss="modal"
          (click)="close()"
          *ngIf="showCancelBtn">
          {{ cancelLabel }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop"></div>
